import MarkdownRenderer from '../Markdown/MarkdownRenderer';

const LegalContentFromMarkdown = () => {

  return (
    <div>
      <MarkdownRenderer file="/content/legal.md" />
    </div>
  );
};

export default LegalContentFromMarkdown;
